import { render, staticRenderFns } from "./Graphics.vue?vue&type=template&id=0644f527"
import script from "./Graphics.vue?vue&type=script&lang=js"
export * from "./Graphics.vue?vue&type=script&lang=js"
import style0 from "./Graphics.vue?vue&type=style&index=0&id=0644f527&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports